<template>
  <label
    for="adjustment_ids[]"
    class="sf-form-check sf-below-2"
    data-testid="adjustment-item"
    @click.stop.prevent="handleClick"
  >
    <input
      type="checkbox"
      name="adjustment_ids[]"
      :checked="modelValue"
      :value="item.id"
      data-testid="adjustment-item-checkbox"
    />
    <div
      class="sf-form-check-content sf-layer-border"
      :class="{ 'sf-layer-white': isChecked }"
    >
      <div class="sf-grid sf-grid-fluid sf-grid-gutter-none">
        <div class="sf-row">
          <div class="sf-col sf-xs-12 sf-md-1 sf-col-middle">
            <div class="sf-level sf-level-around sf-pad-3">
              <span class="sf-form-check-indicator" />
            </div>
          </div>
          <div class="sf-col sf-xs-12 sf-md-11 sf-col-full sf-overflow-scroll">
            <div class="sf-pad-2">
              <div class="sf-level sf-level-small sf-inline-block sf-below-2">
                <span class="sf-level-item sf-title sf-font-s"
                  >{{
                    I18n.t(
                      'adjustment.selective_copy.' +
                        item.category +
                        '_adjustment'
                    )
                  }}
                  #{{ item.ulid }}</span
                >
                <span
                  v-if="forwardOrReverse && item.originalAdjustment.ledger"
                  class="sf-level-item sf-label"
                  >{{
                    I18n.t(
                      'adjustment.copy_types.' + item.originalAdjustmentType,
                      {
                        adjustment_number: '#' + item.originalAdjustment.ulid,
                        period: item.originalAdjustment.ledger.periodName,
                      }
                    )
                  }}</span
                >
                <span
                  v-for="createdAdjustment in filteredAdjustments"
                  :key="createdAdjustment.id"
                  class="sf-level-item sf-label"
                  >{{
                    I18n.t(
                      'adjustment.reverse_copy_types.' +
                        createdAdjustment.originalAdjustmentType,
                      {
                        adjustment_number: '#' + createdAdjustment.ulid,
                        period: createdAdjustment.ledger.periodName,
                      }
                    )
                  }}</span
                >
                <span
                  v-for="tag in computedTags"
                  :key="tag.id"
                  class="sf-level-item sf-label"
                  >{{ tag.name }}</span
                >
              </div>
              <table class="sf-full-height sf-table sf-table-simple">
                <sub-adjustment
                  v-for="subAdjustment in item.subAdjustments"
                  :key="subAdjustment.id"
                  :item="subAdjustment"
                />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </label>
</template>

<script setup lang="ts">
import { Adjustment } from '@app/shared/types/sf-data'

import { computed } from 'vue'

import SubAdjustment from './sub-adjustment.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'ContentItem',
})

interface Props {
  item: Adjustment
  modelValue: boolean
  tags: Array<{ id: number; name: string }>
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    click: [id: number]
  }>()

const I18n = useI18n()

const isChecked = computed(() => props.item.checked)

const computedTags = computed(() => {
  return props.item.tagIds.reduce((acc, tagId) => {
    const tag = props.tags.find((tag) => tag.id === tagId)

    if (tag) {
      acc.push(tag)
    }

    return acc
  }, [] as Array<{ id: number; name: string }>)
})

const filteredAdjustments = computed(() =>
  props.item?.createdAdjustments
    ? props.item.createdAdjustments.filter((adjustment) => adjustment.ledger)
    : []
)

const forwardOrReverse = computed(() => {
  return (
    props.item.originalAdjustmentType === 'forward' ||
    props.item.originalAdjustmentType === 'reverse'
  )
})

function handleClick() {
  emit('click', props.item.id)
}
</script>
